<template>
  <div>
    <HeaderComponent />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="apiErrorMessage" class="error-message">
        {{ apiErrorMessage }}
      </div>
    </div>
  </div>
  <div v-else id="contents1">
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <BreadcrumbsComponent
          v-if="serchCategoryId"
          :key="serchCategoryId"
          title=""
          :categoryId="serchCategoryId"
        />
        <div v-else class="com_breadcrumb1">
          <ul>
            <li><router-link to="/portal-top">HOME</router-link></li>
            <li>{{ categoryName }}</li>
          </ul>
        </div>
        <div class="com_contents3">
          <div class="main_column2">
            <div class="com_search_result_hd1">
              <div>
                <p class="text1">
                  <span>{{ dispKeyWord }}</span
                  >{{ dispTitle }}
                </p>
              </div>
              <div>
                <dl class="com_sort_list1">
                  <dt><span class="com_icon_sort1"></span>並び替え：</dt>
                  <dd>
                    <span class="selected1">{{ currentSortOptionLabel }}</span>
                    <ul class="list1">
                      <li>
                        <a href="#" @click.prevent="updateSortOption('new')"
                          >新着順</a
                        >
                      </li>
                      <li>
                        <a
                          href="#"
                          @click.prevent="updateSortOption('category')"
                          >カテゴリ順</a
                        >
                      </li>
                      <li>
                        <a
                          href="#"
                          @click.prevent="updateSortOption('recommend')"
                          >おすすめ順</a
                        >
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
            <!-- エラーメッセージの表示エリア -->
            <div v-if="apiErrorMessage" class="error-message">
              {{ apiErrorMessage }}
            </div>
            <div class="com_topic_list2">
              <div
                v-for="item in paginatedData"
                :key="item.contentId"
                :class="{ disabled: isProcessing }"
              >
                <div class="meta1">
                  <span class="date1 roboto">{{ item.postPeriod }}</span
                  ><span class="com_tag2">{{ item.subCategoryName }}</span>
                </div>
                <div class="body1">
                  <router-link
                    :to="`/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentId}`"
                    class="com_link1"
                    @click="handleContentsLinkClick"
                    >{{ item.contentsTitle }}</router-link
                  ><span v-if="item.newFlg" class="com_icon_new">NEW</span>
                </div>
                <div v-if="item.fileFlg" class="buttons1">
                  <a
                    href="#"
                    class="com_dl_button2"
                    @click.prevent="
                      downloadFiles(item.categoryId, item.contentId)
                    "
                  >
                    <span>ダウンロード</span>
                  </a>
                </div>
                <div v-if="isKaunetAdmin" class="edit1">
                  <a
                    href="#"
                    @click.prevent="
                      editContents(
                        item.categoryId,
                        item.contentId,
                        item.updateFormPath
                      )
                    "
                    class="com_edit1"
                    ><span></span
                  ></a>
                </div>
              </div>
            </div>
            <content-pagination
              :current-page="currentPage"
              :total-pages="totalPages"
              :items-per-page="itemsPerPage"
              @page-changed="handlePageChange"
            />
          </div>
          <div class="side_search_option1">
            <h2 class="title1">
              <span class="com_icon_option1"></span>さらに絞り込む
            </h2>

            <div class="block_search1">
              <h3 class="title2">キーワードで絞り込む</h3>
              <div>
                <input
                  type="text"
                  name=""
                  placeholder="キーワードを入力"
                  @keyup.enter="narrowSearch"
                  v-model="narrowKeyword"
                  maxlength="50"
                />
                <button type="button" name="" @click="narrowSearch"></button>
              </div>
            </div>
            <div
              v-if="isKaunetAdmin || isNothiceCategory"
              class="block_period1"
            >
              <h3 class="title2">掲載日で絞り込む</h3>
              <input
                class="date_edit1"
                type="date"
                name=""
                v-model="keisaiKikanFrom"
                :max="AppConstants.MAX_DATE_VALUE"
              />
              <span class="t1">〜</span>
              <input
                class="date_edit1"
                type="date"
                name=""
                v-model="keisaiKikanTo"
                :max="AppConstants.MAX_DATE_VALUE"
              />
              <!-- エラーメッセージの表示エリア -->
              <div v-if="errorMessage" class="error-message">
                {{ errorMessage }}
              </div>
              <label v-if="isKaunetAdmin" class="com_checkbox1"
                ><input
                  type="checkbox"
                  name=""
                  v-model="isOutsidePostPeriod"
                /><span class="t2">掲載期間外も表示する</span></label
              >
              <button type="button" class="button1" @click="narrowSearch">
                検索
              </button>
            </div>
            <div class="block_options_group1">
              <div class="com_center1 com_mgb10">
                <a
                  href="javascript:void(0)"
                  class="option_uncheck_all1 com_link1"
                  @click="uncheckAll"
                >
                  <span class="com_icon_cross1"></span>チェックを外す
                </a>
              </div>
              <div
                v-for="(group, index) in groupedTags"
                :key="index"
                class="option_group1"
              >
                <div class="hd1">
                  <label class="com_checkbox1">
                    <input
                      type="checkbox"
                      v-model="group.isCategoryChecked"
                      @change="toggleCategory(group)"
                    />
                    <span class="t1">{{ group.categoryName }}</span>
                  </label>
                </div>
                <div class="body1">
                  <label
                    v-for="(tag, idx) in group.tags"
                    :key="idx"
                    class="com_checkbox1"
                  >
                    <input
                      type="checkbox"
                      v-model="tag.isChecked"
                      @change="checkCategoryStatus(group, tag)"
                    />
                    <span class="t2">{{ tag.tagName }}</span>
                  </label>
                </div>
              </div>
              <hr />
              <button type="button" class="button1" @click="narrowSearch">
                検索
              </button>
              <div class="com_center1 com_mgt5">
                <a
                  href="javascript:void(0)"
                  class="option_uncheck_all1 com_link1"
                  @click="uncheckAll"
                >
                  <span class="com_icon_cross1"></span>チェックを外す
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>
<script lang="ts">
import { AxiosError } from "axios";
import { defineComponent, computed, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  sanitizeInput,
  getTargetDate,
  scrollToTop,
  isTokenAlive,
  trimKeyword,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import apiAuthClient from "@/util/apiClientAuth";
import apiDownloadClient from "@/util/apiClientDownload";
import { useProcessingStore } from "../../store/useProcessingStore";
import ContentPagination from "../controls/ContentPagination.vue";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import BreadcrumbsComponent from "../layout/BreadcrumbsComponent.vue";
import { getPrevRoute } from "@/router";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

interface ContentsItem {
  categoryId: string;
  categoryName: string;
  subCategoryName: string;
  contentId: string;
  postPeriod: string;
  contentsTitle: string;
  imptFlg: boolean;
  newFlg: boolean;
  fileFlg: boolean;
  serchScore: number;
  detailPath: string;
  updateFormPath: string;
}

interface TagItem {
  categoryId: string;
  categoryName: string;
  tagId: string;
  tagName: string;
  isChecked: boolean;
}

interface CategoryGroup {
  categoryId: string;
  categoryName: string;
  tags: TagItem[];
  isCategoryChecked: boolean;
}

export default defineComponent({
  name: "SitetSerchComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    ContentPagination,
    BackToTop,
    BreadcrumbsComponent,
    LoadingOverlay,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { getCategoryIdByName, getCategoryNeme } = useUserParmitionStore();
    const keyWord = computed(() => route.query.keyWord as string); // パラメータのキーワード
    const categoryId = computed(() => route.query.categoryId as string); // パラメータのカテゴリID
    const queryParam = route.params;
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const noticeCategoryId = ref<string | null>(null); // お知らせのカテゴリID
    const isNothiceCategory = ref(false); // お知らせカテゴリかどうかのフラグ
    const categoryName = ref<string | null>(null); // カテゴリ名
    const dispTitle = ref(""); // 表示タイトル
    const dispKeyWord = ref(""); // 表示切キーワード
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const apiErrorMessage = ref(""); // エラーメッセージ（ページの真ん中にでるやつ）
    const narrowKeyword = ref(""); // 絞込キーワード
    const serchCategoryId = ref(""); // 検索カテゴリID
    const contentsListData = ref<ContentsItem[]>([]); // コンテンツ一覧データ
    const tagListData = ref<TagItem[]>([]); // タグデータ
    const processingStore = useProcessingStore(); //状態管理ストア
    const currentPage = ref(1); // 現在ページ
    const itemsPerPage = ref(20); // 1ページに表示する最大件数
    const sortOption = ref("recommend"); // 初期値は "おすすめ順"
    const keisaiKikanFrom = ref(""); // 掲載期間From
    const keisaiKikanTo = ref(""); // 掲載期間To
    const isOutsidePostPeriod = ref(false); // 掲載期間外も表示する
    const isInitError = ref(false); // 初期表示時のエラーフラグ
    const { logoutUser } = useUserStore();
    const isLoading = ref(false);

    const metaSysCateName = computed<string>(() => {
      return (route.meta.systemCatName as string) || "";
    });

    /**
     * 絞込検索実行
     */
    const narrowSearch = async () => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // ------- for debug --------
        outputDebugLogs("絞込検索");
        outputDebugLogs("掲載期間FROM：" + keisaiKikanFrom.value);
        outputDebugLogs("掲載期間TO：" + keisaiKikanTo.value);
        outputDebugLogs("キーワード：" + narrowKeyword.value);
        outputDebugLogs("絞込カテゴリ：" + selectedCategoryIds.value);
        outputDebugLogs("絞込タグ：" + selectedTagIds.value);
        outputDebugLogs("掲載期間外も表示する：" + isOutsidePostPeriod.value);
        // ------- for debug --------

        // エラーメッセージを初期化
        errorMessage.value = "";
        apiErrorMessage.value = "";

        if (keisaiKikanFrom.value && keisaiKikanTo.value) {
          // 両方の値が入力されている場合、大小チェックを行う
          if (
            new Date(keisaiKikanFrom.value) <= new Date(keisaiKikanTo.value)
          ) {
            // チェックOK
          } else {
            errorMessage.value = formatMessage(
              messages.ERR_0005,
              "掲載期間From",
              "掲載期間To"
            );
            return;
          }
        } else if (keisaiKikanFrom.value && !keisaiKikanTo.value) {
          // Fromだけが入力されている場合、Toの値を最大値に設定
          keisaiKikanTo.value = "9999-12-31";
        } else if (!keisaiKikanFrom.value && keisaiKikanTo.value) {
          // Toだけが入力されている場合、Fromの値を最小値に設定
          keisaiKikanFrom.value = "2001-01-01";
        }

        // キーワードをサニタイジング
        const sanitizedKeyWord = trimKeyword(
          sanitizeInput(narrowKeyword.value, true)
        );
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 1文字の場合はNG
        if (sanitizedKeyWord.length == 1) {
          errorMessage.value = formatMessage(
            messages.ERR_0028,
            "キーワード",
            "2"
          );
          return;
        }

        // コンテンツ一覧取得API
        const response = await apiAuthClient.post(
          "/api/SiteSearch/getContentsList",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            keyword: route.query.keyWord,
            categoryId: serchCategoryId.value,
            narrowKeyword: sanitizedKeyWord,
            narrowCategorys: selectedCategoryIds.value,
            narrowTags: selectedTagIds.value,
            postPeriodFrom: keisaiKikanFrom.value,
            postPeriodTo: keisaiKikanTo.value,
            isOutsidePostPeriod: isOutsidePostPeriod.value,
            targetDate: getTargetDate(""),
            isRegSerchHistory: true,
            isNarrowCategory: false,
          }
        );

        // レスポンスからコンテンツリストを取得
        contentsListData.value = response.data.containtsListData;

        // タイトルを設定
        const tempKeyword = ref("");
        if (
          keyWord.value !== undefined ||
          trimKeyword(narrowKeyword.value) !== ""
        ) {
          // キーワードまたは絞込キーワードが入力されている場合は、〇〇の検索結果みたいになる
          dispKeyWord.value = "";
          if (keyWord.value !== undefined) {
            // キーワードが設定されている場合
            tempKeyword.value = keyWord.value;
            outputDebugLogs("キーワード設定あり");
          }

          if (trimKeyword(narrowKeyword.value) !== "") {
            // 絞込キーワードが設定されている場合
            if (tempKeyword.value !== "") {
              // キーワードも設定されている場合、キーワードと絞込キーワードをスペースで結合
              tempKeyword.value = tempKeyword.value + " " + narrowKeyword.value;
              outputDebugLogs("絞込キーワード設定あり");
            } else {
              tempKeyword.value = narrowKeyword.value;
              outputDebugLogs("絞込キーワード設定あり");
            }
          }
          dispKeyWord.value = "「" + tempKeyword.value + "」";
          dispTitle.value =
            "の検索結果:" + contentsListData.value.length + "件";

          sortOption.value = "recommend";
        } else {
          // キーワードおよび絞込キーワードが設定されていない場合はカテゴリ名になる
          dispTitle.value = ":" + contentsListData.value.length + "件";
          if (categoryName.value !== null) {
            dispKeyWord.value = categoryName.value;
          }

          sortOption.value = "new";
        }
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 416:
              // 検索件数オーバー
              apiErrorMessage.value = formatMessage(
                messages.ERR_0023,
                "サイト内検索"
              );
              break;
            default:
              // ほかのエラー
              apiErrorMessage.value = messages.ERR_SYS999;
          }
        } else if (axiosError.request) {
          apiErrorMessage.value = messages.ERR_SYS001;
        } else {
          apiErrorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      } finally {
        // スクロールを一番上に戻す
        scrollToTop();
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    //** カテゴリIDでグループ化したタグのリスト */
    const groupedTags = computed(() => {
      const groups: CategoryGroup[] = [];
      const categoryMap: Record<string, CategoryGroup> = {};

      tagListData.value.forEach((item) => {
        if (!categoryMap[item.categoryId]) {
          categoryMap[item.categoryId] = {
            categoryId: item.categoryId,
            categoryName: item.categoryName,
            tags: [],
            isCategoryChecked: false,
          };
          groups.push(categoryMap[item.categoryId]);
        }
        categoryMap[item.categoryId].tags.push(item);
      });

      // Set initial category checked status based on tags
      groups.forEach((group) => {
        group.isCategoryChecked = group.tags.every((tag) => tag.isChecked);
      });

      return groups;
    });

    //** カテゴリIDのチェックON・OFFで紐づいているタグのチェックをON・OFFする */
    const toggleCategory = (group: CategoryGroup) => {
      group.tags.forEach((tag) => {
        tag.isChecked = group.isCategoryChecked;
        toggleTag(tag);
      });
    };

    //** 同じタグIDのチェック状態を更新する */
    const toggleTag = (tag: TagItem) => {
      tagListData.value.forEach((item) => {
        if (item.tagId === tag.tagId) {
          item.isChecked = tag.isChecked;
        }
      });
    };

    //** カテゴリのチェック状態 */
    const checkCategoryStatus = (group: CategoryGroup, tag: TagItem) => {
      group.isCategoryChecked = group.tags.every((tag) => tag.isChecked);
      toggleTag(tag);
    };

    //** すべてのタグの選択状態を解除します */
    const uncheckAll = () => {
      groupedTags.value.forEach((group) => {
        group.isCategoryChecked = false;
        group.tags.forEach((tag) => {
          tag.isChecked = false;
        });
      });
    };

    //** ページネーションのデータ生成 */
    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return sortedContentsListData.value.slice(start, end);
    });

    //** 頁総数を取得 */
    const totalPages = computed(() => {
      return Math.ceil(contentsListData.value.length / itemsPerPage.value);
    });

    //** ページ切替ハンドラ */
    const handlePageChange = (page: number) => {
      currentPage.value = page;
      // スクロールを一番上に戻す
      scrollToTop();
    };

    //** 並び替え処理 */
    const sortedContentsListData = computed(() => {
      const data = [...contentsListData.value]; // 元のデータをコピーして使用
      switch (sortOption.value) {
        case "new":
          // 新着順 掲載日：降順 コンテンツID：昇順
          return data.sort(
            (a, b) =>
              b.postPeriod.localeCompare(a.postPeriod) ||
              a.contentId.localeCompare(b.contentId)
          );
        case "category":
          // カテゴリ順 カテゴリID
          return data.sort(
            (a, b) =>
              a.categoryId.localeCompare(b.categoryId) ||
              b.postPeriod.localeCompare(a.postPeriod) ||
              a.contentId.localeCompare(b.contentId)
          );
        case "recommend":
        default:
          // おすすめ順
          return data.sort(
            (a, b) =>
              b.serchScore - a.serchScore ||
              b.postPeriod.localeCompare(a.postPeriod) ||
              a.contentId.localeCompare(b.contentId)
          );
      }
    });

    //** 並び替え条件を更新して、ページを最初のページにリセットします */
    const updateSortOption = (option: string) => {
      sortOption.value = option;
      currentPage.value = 1; // 並び替え時にページを最初にリセット
    };

    //** 現在の並び替え条件を表示 */
    const currentSortOptionLabel = computed(() => {
      switch (sortOption.value) {
        case "new":
          return "新着順";
        case "category":
          return "カテゴリ順";
        case "recommend":
        default:
          return "おすすめ順";
      }
    });

    /**
     * コンテンツ編集
     * コンテンツ登録画面に編集モードで遷移します
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const editContents = (
      ctgyId: string,
      ctsId: string,
      updFormPath: string
    ) => {
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;

      try {
        outputDebugLogs("カテゴリID: " + ctgyId);
        outputDebugLogs("コンテンツID: " + ctsId);

        // コンテンツ登録画面へ編集モードで遷移
        router.push({
          path: "/" + updFormPath,
          query: {
            categoryId: ctgyId,
            contentsId: ctsId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_UPDATE,
          },
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    //** 選択されているカテゴリIDをカンマ区切りで取得します */
    const selectedCategoryIds = computed(() => {
      return groupedTags.value
        .filter((group) => group.isCategoryChecked)
        .map((group) => group.categoryId)
        .join(",");
    });

    //** 選択されているタグIDをカンマ区切りで取得します */
    const selectedTagIds = computed(() => {
      return groupedTags.value
        .flatMap((group) => group.tags)
        .filter((tag) => tag.isChecked)
        .map((tag) => tag.tagId)
        .join(",");
    });

    /**
     * ファイルダウンロード
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const downloadFiles = async (ctgyId: string, ctsId: string) => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // エラーメッセージ初期化
        apiErrorMessage.value = "";

        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post("/api/download", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          userId: userId.value,
          agCode: agCode.value,
          categoryId: ctgyId,
          contentId: ctsId,
          fileName: "",
          targetDate: getTargetDate(""),
          pseudoUserId: pseudoUserId.value,
          pseudoAgCode: pseudoAgCode.value,
          screenName: categoryName.value,
        });

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        apiErrorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    const getInitData = async () => {
      // ***** Debag Log *********
      outputDebugLogs("キーワード: " + keyWord.value);
      outputDebugLogs("カテゴリ: " + categoryId.value);
      outputDebugLogs("meta情報のシステムカテゴリ名: " + metaSysCateName.value);
      //outputDebugLogs("プロパティのキーワード " + props.keyword);
      // ***** Debag Log *********

      // エラーメッセージを初期化
      errorMessage.value = "";
      apiErrorMessage.value = "";
      currentPage.value = 1;

      isLoading.value = true;
      try {
        // お知らせのカテゴリIDを取得
        noticeCategoryId.value = getCategoryIdByName(
          AppConstants.CATEGORY_NAME_INFO
        );

        var isRegSerchHistory = false;
        // プロパティでカテゴリIDが渡されている場合は、カテゴリ名を取得
        if (metaSysCateName.value != "") {
          serchCategoryId.value =
            getCategoryIdByName(metaSysCateName.value) || "";

          categoryName.value = getCategoryNeme(serchCategoryId.value);

          outputDebugLogs("サイト内検索ではない");
          outputDebugLogs("カテゴリID: " + serchCategoryId.value);
          outputDebugLogs("カテゴリ名: " + categoryName.value);
          outputDebugLogs("お知らせのカテゴリID ：" + noticeCategoryId.value);

          isNothiceCategory.value =
            noticeCategoryId.value == serchCategoryId.value;

          // 検索履歴の登録はしない
          isRegSerchHistory = false;
        } else {
          categoryName.value = "サイト内検索";
          serchCategoryId.value = categoryId.value;

          isNothiceCategory.value = false;
          isRegSerchHistory = true;
        }
        outputDebugLogs("カテゴリ名: " + categoryName.value);

        outputDebugLogs("isNothiceCategory：" + isNothiceCategory.value);
        outputDebugLogs("isRegSerchHistory：" + isRegSerchHistory);

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        if (route.query.keyWord) {
          outputDebugLogs("サイト内検索");
        } else {
          outputDebugLogs("アイコンメニュー");
        }

        // コンテンツ一覧取得API
        const response = await apiAuthClient.post(
          "/api/SiteSearch/getContentsList",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            keyword: route.query.keyWord,
            categoryId: serchCategoryId.value,
            narrowKeyword: "",
            narrowCategorys: "",
            narrowTags: "",
            postPeriodFrom: "",
            postPeriodTo: "",
            isOutsidePostPeriod: false,
            targetDate: getTargetDate(""),
            isRegSerchHistory: isRegSerchHistory,
            isNarrowCategory: true,
          }
        );

        // レスポンスからコンテンツ一覧を取得
        contentsListData.value = response.data.containtsListData;
        // レスポンスからタグ一覧を取得
        tagListData.value = response.data.tagListData;
        // タイトルを設定
        if (categoryName.value == "サイト内検索") {
          // サイト内検索の場合
          if (keyWord.value !== undefined) {
            dispKeyWord.value = "「" + keyWord.value + "」";
            dispTitle.value =
              "の検索結果:" + contentsListData.value.length + "件";
          }

          // 並び替えは、おすすめ順を初期値にする
          sortOption.value = "recommend";
        } else {
          // お知らせ一覧など、キーワードで検索しないやつ
          dispTitle.value = ":" + contentsListData.value.length + "件";
          if (categoryName.value !== null) {
            dispKeyWord.value = categoryName.value;
          }

          // 並び替えは、新着順を初期値にする
          sortOption.value = "new";
        }

        // 遷移元のルーター情報取得
        let prevRoute = getPrevRoute();

        // 遷移元がコンテンツ詳細の場合
        if (prevRoute && prevRoute.name == "Contents") {
          // セッションストレージから遷移前のページ番号取得
          let prevCurrentPage = sessionStorage.getItem(
            AppConstants.CURRENT_PAGE_SESSION_NAME
          );

          // 遷移前のページ番号が存在する場合
          if (
            prevCurrentPage &&
            parseInt(prevCurrentPage) <= totalPages.value
          ) {
            // 遷移前のページ番号に移動
            currentPage.value = parseInt(prevCurrentPage);
          }
        }
        // セッションストレージから遷移前のページ番号削除
        sessionStorage.removeItem(AppConstants.CURRENT_PAGE_SESSION_NAME);

        isInitError.value = false;

        scrollToTop();
      } catch (error: unknown) {
        // エラー時は初期表示エラーフラグをON
        isInitError.value = true;
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 401:
              logoutUser();
              alert(messages.ERR_USER001);
              router.push("/login");
              break;
            case 416:
              // 取得件数オーバー
              apiErrorMessage.value = formatMessage(
                messages.ERR_0023,
                "サイト内検索"
              );
              break;
            default:
              // その他のエラー
              apiErrorMessage.value = messages.ERR_SYS999;
          }
        } else if (axiosError.request) {
          apiErrorMessage.value = messages.ERR_SYS001;
        } else {
          apiErrorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      } finally {
        isLoading.value = false;
      }
    };

    /**
     * コンテンツリンク押下時
     */
    const handleContentsLinkClick = () => {
      // セッションストレージに現在ページを保存
      sessionStorage.setItem(
        AppConstants.CURRENT_PAGE_SESSION_NAME,
        currentPage.value.toString()
      );
    };

    // ルートの変更を監視
    watch(
      () => route.fullPath,
      (newPath, oldPath) => {
        // ルートが変更されたときに実行する処理
        outputDebugLogs(`URL変更 from ${oldPath} to ${newPath}`);
        getInitData();
      }
    );

    /**
     * 初期処理
     */
    onMounted(async () => {
      await getInitData();
    });
    return {
      queryParam,
      isKaunetAdmin,
      isNothiceCategory,
      dispTitle,
      categoryName,
      dispKeyWord,
      errorMessage,
      apiErrorMessage,
      narrowSearch,
      narrowKeyword,
      isOutsidePostPeriod,
      contentsListData,
      tagListData,
      isProcessing: processingStore.isProcessing,
      groupedTags,
      toggleCategory,
      checkCategoryStatus,
      uncheckAll,
      currentPage,
      itemsPerPage,
      paginatedData,
      totalPages,
      handlePageChange,
      updateSortOption,
      currentSortOptionLabel,
      editContents,
      keisaiKikanFrom,
      keisaiKikanTo,
      downloadFiles,
      isInitError,
      AppConstants,
      serchCategoryId,
      handleContentsLinkClick,
      isLoading,
    };
  },
});
</script>

<style scoped>
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
</style>
